var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{style:("direction:"+_vm.lang.dir)},[_c('router-view')],1),_c('FloatButton',{directives:[{name:"show",rawName:"v-show",value:(!_vm.withsidemenu),expression:"!withsidemenu"}]}),_c('License')],1)}
var staticRenderFns = []

export { render, staticRenderFns }